import React, {useEffect, useState} from 'react';
import {Button} from '../../ui-components/Button/button';
import {ChevronDownWhite, ChevronUpWhite} from '../../ui-components/Iconpack';
import Tracker from '../../lib/analytics/tracker';
import {EventNames, EventProperty} from '../../lib/analytics/events';
import {encodeUrl} from '../../utils/helper';

interface imageMetadata {
    name: string;
    cdn_url: string;
    thumbnail_url: string;
    uid: string;
}
interface imagesToRender {
    assignBackgroundImageUid: (imageUid: string) => void;
    currentImageUid: string;
    name: string;
    value: Array<imageMetadata>;
}

export default function BackgroundTexturesDisplay({
    name,
    value,
    assignBackgroundImageUid,
    currentImageUid,
}: imagesToRender) {
    const [backgroundImageUid, setBackgroundImageUid] = useState('');
    const [viewAll, setViewAll] = useState(false);

    const slicedBgOptions = value?.slice(0, viewAll ? value.length : 6);

    useEffect(() => {
        setBackgroundImageUid(currentImageUid);
    }, []);

    return (
        <div className='relative'>
            <span className='text-[12px] font-[600] text-[#FFFFFF]'>{name}</span>
            <div className='mt-4 grid grid-cols-7 items-center justify-center gap-2 md:grid-cols-3'>
                {slicedBgOptions &&
                    slicedBgOptions.map((texture: imageMetadata) => (
                        <img
                            key={texture.uid}
                            src={encodeUrl(texture.cdn_url)}
                            alt={texture.name}
                            className={`h-[53px] w-[53px] cursor-pointer rounded-[4px] object-cover`}
                            style={{border: texture.uid === backgroundImageUid ? '3px solid grey' : 'none'}}
                            onClick={() => {
                                Tracker.trackEvent(EventNames.TRANSFORMATION_BACKGROUND_REPLACED_IMAGE, {
                                    [EventProperty.BackgroundUid]: texture.uid,
                                });
                                setBackgroundImageUid(texture.uid);
                                assignBackgroundImageUid(texture.uid);
                            }}></img>
                    ))}
            </div>
            {value.length > 6 && !viewAll && (
                <div className='flex items-center justify-center'>
                    <Button
                        variant='nude'
                        className='items-center justify-center text-[12px] font-[700] text-[#FFFFFF] hover:bg-transparent'
                        icon
                        onClick={() => setViewAll(!viewAll)}>
                        {viewAll ? 'Hide' : 'View All'}
                        {viewAll ? (
                            <ChevronUpWhite width={12} height={12} />
                        ) : (
                            <ChevronDownWhite width={12} height={12} />
                        )}
                    </Button>
                </div>
            )}
        </div>
    );
}
